import React, { useState, useEffect } from 'react'
import { ResultListProps } from './types'
import { SearchResultItem, HitCategory } from '@apps/Shared/Services/Search/interfaces'
import { LinkType, LinkCategory } from '@sharedComponents/Links/types'
import LinkBadge from '@sharedComponents/Links/LinkBadge'
import Pagination from '@sharedComponents/Pagination'
import { getDataForPage } from '@sharedComponents/Pagination/utils'
import includes from 'lodash/includes'

const PageSize = 10

const ResultList = (props: ResultListProps) => {
    const [pageData, setPageData] = useState<SearchResultItem[]>([])

    const onSelectPage = (page: number, data: SearchResultItem[]) => {
        setPageData(data)
    }

    const renderItem = (item: SearchResultItem, index: number) => {
        let linkCategory =
            LinkCategory[item.hitLinkCategory] || LinkCategory.Page
        linkCategory =
            item.hitCategory === HitCategory.EService
                ? LinkCategory.EService
                : linkCategory
        let linkType =
            linkCategory === LinkCategory.Document
                ? LinkType.Download
                : LinkType.Intern
        linkType = includes(item.url, `http`) ? LinkType.Extern : linkType

        return (
            <div className="result-list__item-wrapper" key={index}>
                <LinkBadge
                    size="lg"
                    badgeIcon={item.icon}
                    category={linkCategory}
                    title={item.title}
                    date={item.date}
                    linkType={linkType}
                    teaser={item.excerpt}
                    link={item.url}
                />
            </div>
        )
    }

    useEffect(() => {
        if (props.items) {
            const defaultPageData = getDataForPage(1, PageSize, props.items)
            setPageData(defaultPageData)
        }
    }, [props.items])

    return (
        <div className="result-list">
            {pageData.map((item, index) => renderItem(item, index))}
            <div className="result-list__pagination">
                <Pagination
                    pageSize={PageSize}
                    totalCount={props.items.length || 0}
                    onSelectPage={onSelectPage}
                    data={props.items || []}
                />
            </div>
        </div>
    )
}

export default ResultList
